module.exports = __webpack_public_path__ + "static/media/il-no-sweeps@2x.0c076132.png";